import React, { useState } from "react";
import {
  Box,
  TextField,
  MenuItem,
  Button,
  Snackbar,
  Alert,
  InputAdornment,
} from "@mui/material";
import FeedbackIcon from "@mui/icons-material/Feedback";
import BugReportIcon from "@mui/icons-material/BugReport";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import emailjs from "emailjs-com";

const FEEDBACK_TYPES = [
  {
    value: "Feedback",
    label: "Feedback",
    icon: <FeedbackIcon fontSize="small" color="primary" />,
  },
  {
    value: "Bug Report",
    label: "Bug Report",
    icon: <BugReportIcon fontSize="small" color="primary" />,
  },
  {
    value: "Error Report",
    label: "Error Report",
    icon: <ErrorOutlineIcon fontSize="small" color="primary" />,
  },
];

export default function ContactForm({ fromPage }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    type: "",
    message: "",
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleChange = (e) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .send(
        "service_7nh1thz",
        "template_4z2fl1j",
        {
          name: formData.name,
          email: formData.email,
          type: formData.type,
          message: formData.message,
          from_page: fromPage || window.location.origin,
          to_email: "social@etfindia.com",
        },
        "mkrfej4tbiQvBelB7"
      )
      .then(() => {
        setSnackbarOpen(true);
        setFormData({ name: "", email: "", type: "", message: "" });
      })
      .catch((err) => console.error("Email failed:", err));
  };

  const fieldSx = {
    background: "#fff",
    color: "#156078",
    borderRadius: 2,
  };

  return (
    <>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          label="Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          size="small"
          required
          margin="normal"
          InputProps={{
            style: fieldSx,
            endAdornment: (
              <InputAdornment position="end" sx={{ color: "#17332F" }}>
                👤
              </InputAdornment>
            ),
          }}
          InputLabelProps={{ style: { color: "#17332F" } }}
          sx={{ mb: 2 }}
        />
        <TextField
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          fullWidth
          size="small"
          required
          margin="normal"
          InputProps={{
            style: fieldSx,
            endAdornment: (
              <InputAdornment position="end" sx={{ color: "#17332F" }}>
                @
              </InputAdornment>
            ),
          }}
          InputLabelProps={{ style: { color: "#17332F" } }}
          sx={{ mb: 2 }}
        />
        <TextField
          select
          label="Type"
          name="type"
          value={formData.type}
          onChange={handleChange}
          fullWidth
          size="small"
          required
          margin="normal"
          InputProps={{ style: fieldSx }}
          InputLabelProps={{ style: { color: "#17332F" } }}
          sx={{ mb: 2 }}
        >
          {FEEDBACK_TYPES.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {opt.icon}
                {opt.label}
              </Box>
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="Message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          fullWidth
          size="small"
          required
          multiline
          rows={4}
          margin="normal"
          InputProps={{ style: fieldSx }}
          InputLabelProps={{ style: { color: "#17332F" } }}
          sx={{ mb: 2 }}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{
            mt: 2,
            py: 1,
            fontWeight: "bold",
            fontSize: "1.01rem",
            background: "#17332F",
            color: "#FAFAFA",
            borderRadius: 2,
            letterSpacing: 1,
            boxShadow: "0px 4px 24px -12px #17332F",
            transition: "filter .2s",
            "&:hover": { background: "#156078", filter: "brightness(1.08)" },
          }}
        >
          Send Message
        </Button>
      </Box>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="success" sx={{ width: "100%" }}>
          Feedback sent successfully! Our support team will contact you.
        </Alert>
      </Snackbar>
    </>
  );
}
